import { Divider, List, ListItem, type Theme, Typography } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { type ReactNode } from 'react';
import { Link } from '#components/Link/index.tsx';

type ComponentProps = {
  [key: string]: unknown;
  children: ReactNode | ReactNode[];
  sx?: SystemStyleObject<Theme>;
};

export const p = ({ children, sx, ...otherProps }: ComponentProps) => (
  <Typography sx={{ ...sx, marginBottom: 1 }} variant="body1" {...otherProps}>
    {children}
  </Typography>
);

export const h1 = ({ children, sx, ...otherProps }: ComponentProps) => (
  <Typography sx={{ ...sx, fontWeight: 'bold', marginBottom: 2 }} variant="h1" {...otherProps}>
    {children}
  </Typography>
);

export const h2 = ({ children, sx, ...otherProps }: ComponentProps) => (
  <Typography sx={{ ...sx, fontWeight: 'bold', marginBottom: 2 }} variant="h2" {...otherProps}>
    {children}
  </Typography>
);

export const h3 = ({ children, sx, ...otherProps }: ComponentProps) => (
  <Typography sx={{ ...sx, fontWeight: 'bold', marginBottom: 2 }} variant="h3" {...otherProps}>
    {children}
  </Typography>
);

export const h4 = ({ children, sx, ...otherProps }: ComponentProps) => (
  <Typography sx={{ ...sx, fontWeight: 'bold', marginBottom: 2 }} variant="h4" {...otherProps}>
    {children}
  </Typography>
);

export const h5 = ({ children, sx, ...otherProps }: ComponentProps) => (
  <Typography sx={{ ...sx, fontWeight: 'bold', marginBottom: 2 }} variant="h5" {...otherProps}>
    {children}
  </Typography>
);

export const h6 = ({ children, sx, ...otherProps }: ComponentProps) => (
  <Typography sx={{ ...sx, fontWeight: 'bold', marginBottom: 1 }} {...otherProps}>
    {children}
  </Typography>
);

export const a = ({ children, ...otherProps }: ComponentProps) => <Link {...otherProps}>{children}</Link>;

export const ul = ({ children, ...otherProps }: ComponentProps) => <List {...otherProps}>{children}</List>;

export const li = ({ children, ...otherProps }: ComponentProps) => <ListItem {...otherProps}>{children}</ListItem>;

export const hr = (props: ComponentProps) => <Divider {...props} />;
